import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { db } from '../firebase/firebaseConfig';
import { collection, getDocs, setDoc, doc, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import '../styling/success.css';

const Anesthesia = ({ handleSuccessDataSubmission }) => {
  const [userEmail, setUserEmail] = useState('');
  const [patientId, setPatientId] = useState('');
  const [patientPhoneNumber, setPatientPhoneNumber] = useState('');
  const [otherInfo, setOtherInfo] = useState(''); 

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      setUserEmail(user.email);
    }
  }, []);

  const handleSuccessSubmit = useCallback(async (e) => {
    e.preventDefault();

    if (patientId && patientPhoneNumber && otherInfo) {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        alert('No user logged in');
        return;
      }

      const userDocSnapshot = await getDocs(
        query(collection(db, 'users'), where('email', '==', user.email.toLowerCase()))
      );

      if (userDocSnapshot.empty) {
        alert('User data not found');
        return;
      }

      const userDoc = userDocSnapshot.docs[0];
      const practice = userDoc.data().practice;

      const submissionData = {
        userEmail,
        patientId,
        patientPhoneNumber,
        otherInfo,
        practice,
      };

      await handleSuccessDataSubmission(submissionData);

      const entryRef = collection(db, 'Success', 'successRefDoc', 'Anesthesia');
      await setDoc(doc(entryRef, patientId), {
        userEmail,
        patientId,
        patientPhoneNumber,
        otherInfo,
        practice,
        completionDate: new Date().toISOString().split('T')[0],
      });

      setPatientId('');
      setPatientPhoneNumber('');
      setOtherInfo('');
    } else {
      toast.error('Please complete all fields before submitting.');
    }
  }, [patientId, patientPhoneNumber, otherInfo, userEmail, handleSuccessDataSubmission]);

  return (
    <div className="submit-no-issue-data">
      <h1>Anesthesia Procedure Success</h1>
      <form onSubmit={handleSuccessSubmit}>
        <div className="form-group">
          <label>
            Patient ID:
            <input
              type="text"
              value={patientId}
              onChange={(e) => setPatientId(e.target.value)}
              required
            />
          </label>
        </div>
        <div className="form-group">
          <label>
            Patient Phone Number:
            <input
              type="text"
              value={patientPhoneNumber}
              onChange={(e) => setPatientPhoneNumber(e.target.value)}
              required
            />
          </label>
        </div>
        <label>
          Other Patient Info:
          <textarea
            value={otherInfo}
            onChange={(e) => setOtherInfo(e.target.value)}
            required
          />
        </label>
        <button type="submit">Confirm and Submit</button>
      </form>
    </div>
  );
};

export default Anesthesia;
